/* LAUNCH Sticky Buy Now: add the selected product, then open standard checkout. */
(() => {
  if (window.__launchStickyDirectCheckoutBound) return;
  window.__launchStickyDirectCheckoutBound = true;

  function findMainForm(sticky) {
    const formId = sticky?.getAttribute('form');
    if (formId) {
      const found = document.getElementById(formId);
      if (found && found.matches('form')) return found;
    }
    return document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
  }

  function showError(form, message) {
    const node = form.querySelector('.sticky-atc__direct-checkout-error');
    if (node) {
      node.textContent = message;
      node.hidden = !message;
    }
  }

  function syncButtonAvailability() {
    document.querySelectorAll('form[data-type="sticky-direct-checkout-form"]').forEach(form => {
      const sticky = form.closest('sticky-atc');
      const mainInput = findMainForm(sticky)?.querySelector('input[name="id"]');
      const stickyInput = form.querySelector('input[name="id"]');
      const button = form.querySelector('[data-sticky-direct-checkout]');
      if (!button || button.dataset.working === 'true') return;
      if (mainInput) {
        if (stickyInput && mainInput.value) stickyInput.value = mainInput.value;
        const unavailable = mainInput.disabled || !mainInput.value;
        button.disabled = unavailable;
        button.setAttribute('aria-disabled', String(unavailable));
      }
    });
  }

  // Variant selection updates can be asynchronous in Ella; sync after updates.
  document.addEventListener('change', () => {
    window.setTimeout(syncButtonAvailability, 60);
    window.setTimeout(syncButtonAvailability, 350);
  });
  document.addEventListener('DOMContentLoaded', syncButtonAvailability);
  document.addEventListener('shopify:section:load', syncButtonAvailability);
  window.addEventListener('pageshow', syncButtonAvailability);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="sticky-direct-checkout-form"]')) return;
    event.preventDefault();

    const button = form.querySelector('[data-sticky-direct-checkout]');
    if (!button || button.dataset.working === 'true') return;
    const sticky = form.closest('sticky-atc');
    const mainForm = findMainForm(sticky);
    const mainInput = mainForm?.querySelector('input[name="id"]');
    const stickyInput = form.querySelector('input[name="id"]');
    const variantId = mainInput?.value || stickyInput?.value;

    if (!variantId || (mainInput && mainInput.disabled)) {
      showError(form, 'Please select an available product variant.');
      return;
    }

    // Use the main product form when available so selling plans / properties
    // are carried over. Never clear the customer's existing cart.
    const payload = new FormData(mainForm || form);
    payload.set('id', variantId);
    const qtyRaw = mainForm?.querySelector('[name="quantity"]')?.value
      || form.querySelector('[name="quantity"]')?.value;
    const qty = Number.parseInt(qtyRaw, 10);
    payload.set('quantity', String(Number.isFinite(qty) && qty > 0 ? qty : 1));
    payload.delete('return_to');
    payload.delete('sections');
    payload.delete('sections_url');

    showError(form, '');
    button.dataset.working = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: payload
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || `Unable to add item (${response.status}).`);
      }
      window.location.assign('/checkout');
    } catch (error) {
      showError(form, error?.message || 'Unable to proceed to checkout. Please try again.');
      button.dataset.working = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      syncButtonAvailability();
    }
  });
})();
